import React, { useState, useEffect } from "react";
import Spacer from "../../components/layouts/Spacer";
import { Views } from "react-big-calendar";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { convertSchedulingEventsToCalender } from "../../components/util/helpers";
import ReplacementsModal from "../employees/replacements/ReplacementsModal";
import AddEmployeeScheduling from "./components/AddEmployeeScheduling";
import moment from "moment";
import Calender from "./components/Calender";
import SchedulingHeader from "./components/SchedulingHeader";
import EventModal from "./components/EventModal";
import ApprovalModal from "./components/ApprovalModal";
import { loadPage } from "./schedulingSlice";
import { loadAbsences } from "../employeeAbsences/employeeAbsencesSlice";
import { listHolidays, getPatient } from "../../api/server";
import { FormattedMessage } from "react-intl";
import { convertSchedulingEventsFromCalender } from "../../components/util/helpers";
import { editSchedulingEvent } from "../scheduling/schedulingSlice";
import SchedulingWrapper from "../scheduling/components/index.style";

import _ from "lodash";

const pallette = [
  {
    primary: "#53C31A",
    border: "#C8D7C2",
    bg: "#F1FBEE",
  },
  {
    primary: "#F99646",
    border: "#F6BD8D",
    bg: "#FDEEE0",
  },
  {
    primary: "#6C64FE",
    border: "#D8D6FC",
    bg: "#F2EFFF",
  },
];

const EmployeeScheduling = (props) => {
  const { activeTab } = props;
  const location = useLocation();
  const [currentDate, setCurrentDate] = useState(moment());
  const [calenderView, setCalenderView] = useState(Views.MONTH);
  const [events, setEvents] = useState([]);
  const [originalEvents, setOriginalEvents] = useState([]);
  const [visible, setVisible] = useState(false);
  const [activeEvent, setActiveEvent] = useState(null);
  const [ordersIds, setOrdersIds] = useState([]);
  const [patientsPallette, setPatientsPallette] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [approvalModalVisible, setApprovalModalVisible] = useState(false);
  const [originalActiveEvent, setOriginalActiveEvent] = useState(null);
  const [holidays, setHolidays] = useState([]);
  const [activePatient, setActivePatient] = useState({});
  const [replacementsModalVisible, setReplacementsModalVisible] =
    useState(false);
  const [addSchedulingVisible, setAddSchedulingVisible] = useState(false);
  const [employeePatients, setEmployeePatients] = useState([]);
  const [newEventInitialValues, setNewEventInitialValues] = useState(null);
  const [monthAbsences, setMonthAbsences] = useState([]);

  const [triggerQueryTimestamp, setTriggerQueryTimestamp] = useState(null);

  const activeEmployee = useSelector(
    (state) => state.employeeDetails.activeEmployee
  );
  const loadLoading = useSelector(
    (state) => state.pendingActions["employeeScheduling/load"]
  );

  const createLoading = useSelector(
    (state) => state.pendingActions["employeeScheduling/create"]
  );
  const editLoading = useSelector(
    (state) => state.pendingActions["employeeScheduling/edit"]
  );
  const deleteLoading = useSelector(
    (state) => state.pendingActions["employeeScheduling/delete"]
  );
  const loading = loadLoading || createLoading || editLoading || deleteLoading;

  const { page: schedulingPage } = useSelector(
    (state) => state.employeeScheduling
  );
  const { items, replacements, order_time_extractions } = schedulingPage;
  const absences = useSelector((state) => state.employeeAbsences.absences);

  const dispatch = useDispatch();

  useEffect(() => {
    if (
      location.state &&
      location.state.activeTab &&
      location.state.activeTab === "scheduling"
    ) {
      const date = moment().set("year", location.state.year);
      date.set("month", location.state.month - 1).startOf("month");
      setCurrentDate(date);
    }
  }, [location.state]);

  useEffect(() => {
    let arr = [];
    for (let i = 0; i < absences.length; i++) {
      const range = moment.range(
        absences[i].effective_from,
        absences[i].effective_to
      );
      const monthRange = moment.range(
        moment(currentDate).startOf("month"),
        moment(currentDate).endOf("month")
      );
      if (range.overlaps(monthRange, { adjacent: false })) {
        arr.push(absences[i]);
      }
    }
    setMonthAbsences(arr);
  }, [absences]);

  useEffect(() => {
    const patients =
      events &&
      events.length > 0 &&
      events
        .map((i) => i.order.patient)
        .filter((v, j, a) => a.findIndex((t) => t.id === v.id) === j);

    const sortedPatients =
      patients &&
      _.sortBy(patients, [
        function (o) {
          return o.surename;
        },
      ]);
    setEmployeePatients(sortedPatients);
  }, [events]);

  const onHideApprovalModal = () => {
    setApprovalModalVisible(false);
    convertItems();
    setFilteredOrders([]);
  };

  const onlaunchApprovalModal = () => {
    setApprovalModalVisible(true);
  };

  const hideEmployeeScheduling = () => {
    setAddSchedulingVisible(false);
  };

  const createEvent = (newEvent) => {
    const initial = {
      date: moment(newEvent.start).format(),
      start: moment(newEvent.start).format(),
      start_hour: moment(newEvent.start).format(),
      end: moment(newEvent.end).format(),
      end_hour: moment(newEvent.end).format(),
    };
    setNewEventInitialValues(initial);
    setAddSchedulingVisible(true);
  };

  useEffect(() => {
    if (activeTab === "employee_scheduling") {
      reload();
      const filter = {
        $and: [
          {
            date: {
              $gte: moment(currentDate).startOf("month").format(),
            },
          },
          {
            date: {
              $lte: moment(currentDate).endOf("month").format(),
            },
          },
        ],
      };
      listHolidays({ filter }).then(({ error, data }) => {
        if (data) {
          setHolidays(data.items);
        }
      });
    }
  }, [dispatch, currentDate, activeTab]);

  useEffect(() => {
    setFilteredOrders([]);
    setPatientsPallette([]);
  }, [currentDate]);

  const reload = async () => {
    const startDate = moment(currentDate).startOf("month");
    var endDate = moment(currentDate).endOf("month");
    dispatch(loadAbsences(activeEmployee.id));
    return dispatch(
      loadPage({
        filter: {
          date: {
            $gte: startDate.format(),
            $lte: endDate.format(),
          },
        },
        query: {
          from: startDate.format(),
          end: endDate.format(),
        },
      })
    );
  };

  useEffect(() => {
    const ids = [...new Set(events.map((obj) => obj.order.id))];
    setOrdersIds(ids);
    let idsPallette = [];
    ids.forEach((item, i) => {
      idsPallette.push({
        orderId: ids[i],
        primary: pallette[i] ? pallette[i].primary : "#53C31A",
        border: pallette[i] ? pallette[i].border : "#C8D7C2",
        bg: pallette[i] ? pallette[i].bg : "#F1FBEE",
      });
    });
    setPatientsPallette(idsPallette);
  }, [events]);

  useEffect(() => {
    convertItems();
    setActiveEvent(null);
  }, [items]);

  const convertItems = () => {
    const ghosts =
      replacements && replacements.length > 0
        ? replacements.map((i) => ({ ...i, ghost: true }))
        : [];
    const convertedToCalender = convertSchedulingEventsToCalender([
      ...items,
      ...ghosts,
    ]);
    setEvents(convertedToCalender);
    setOriginalEvents(convertedToCalender.filter((i) => !i.ghost));
  };

  const changeEvents = (arr) => {
    setEvents(arr);
  };

  const onNavigate = (val) => {
    setCurrentDate(moment(val));
    setCalenderView(Views.DAY);
  };

  const onCalenderViewChanged = (val) => {
    setCalenderView(val);
  };

  const onChangeView = (e) => {
    setCalenderView(e.target.value);
  };

  const viewEvent = async (newEvent) => {
    setActiveEvent({
      ...newEvent,
      ghostEmployeeId: newEvent.ghost && newEvent.employee_id,
    });
    const isAdmin = location.pathname.includes("admin");
    const params = {
      id: newEvent.order.patient_id,
      branchId: newEvent.order.patient.branch,
      admin: isAdmin,
    };
    const response = await getPatient(params);
    setActivePatient(response.data);
    setOriginalActiveEvent(newEvent);
    setVisible(true);
  };

  const goToDayView = (newEvent) => {
    setCurrentDate(moment(newEvent.start));
    setCalenderView(Views.DAY);
  };

  const handleCancel = (e) => {
    setVisible(false);
    setActiveEvent(null);
  };

  const onFilterPatientsChanged = (orderId, val) => {
    const newFiltered = val
      ? filteredOrders.filter((item) => item !== orderId)
      : [...filteredOrders, orderId];
    setFilteredOrders(newFiltered);
  };

  const onNextMonth = () => {
    setCurrentDate(moment(currentDate).add(1, "months").startOf("month"));
  };
  const onPreviousMonth = () => {
    setCurrentDate(moment(currentDate).subtract(1, "months").startOf("month"));
  };

  const onNextDate = () => {
    if (calenderView === Views.MONTH) {
      setCurrentDate(moment(currentDate).add(1, "months").startOf("month"));
    } else if (calenderView === Views.WEEK) {
      const fromMonth = moment(currentDate).startOf("week").get("month");
      const toMonth = moment(currentDate)
        .add(7, "days")
        .startOf("week")
        .get("month");
      if (fromMonth < toMonth) {
        setCurrentDate(moment(currentDate).add(7, "days").endOf("week"));
      } else {
        setCurrentDate(moment(currentDate).add(7, "days").startOf("week"));
      }
    } else if (calenderView === Views.DAY) {
      setCurrentDate(moment(currentDate).add(1, "days"));
    }
  };
  const onPreviousDate = () => {
    if (calenderView === Views.MONTH) {
      setCurrentDate(
        moment(currentDate).subtract(1, "months").startOf("month")
      );
    } else if (calenderView === Views.WEEK) {
      const fromMonth = moment(currentDate).endOf("week").get("month");
      const toMonth = moment(currentDate)
        .subtract(7, "days")
        .endOf("week")
        .get("month");
      if (fromMonth > toMonth) {
        setCurrentDate(moment(currentDate).subtract(7, "days").startOf("week"));
      } else {
        setCurrentDate(moment(currentDate).subtract(7, "days").endOf("week"));
      }
    } else if (calenderView === Views.DAY) {
      setCurrentDate(moment(currentDate).subtract(1, "days"));
    }
  };

  const calenderEvents = activeEvent
    ? [
      ...events.filter((item) => item.id !== activeEvent.id),
      { ...activeEvent },
    ]
    : events;

  const approvalEvents = calenderEvents.filter((item) => !item.ghost);

  const onLaunchReplacementsModal = (record) => {
    setReplacementsModalVisible(true);
  };
  const onHideReplacementsModal = () => {
    setReplacementsModalVisible(false);
  };

  const triggerFetch = (timestamp) => {
    setTriggerQueryTimestamp(timestamp);
  };

  const changeEvent = async (changed, start, end) => {
    setActiveEvent({ ...changed, start, end });
    const converted = convertSchedulingEventsFromCalender({
      ...changed,
      start,
      end,
    });
    const params = {
      patientId: converted.order.patient.id,
      branchId: converted.order.patient.branch,
      schedulingEvent: {
        deleted: !changed.ghost ? converted.deleted : null,
        deleted_replacement: changed.ghost ? changed.id : null,
        new: { ...converted },
      },
    };
    await dispatch(editSchedulingEvent(params));
    setVisible(false);
    reload();
  };
  return (
    <SchedulingWrapper className={"surface"}>
      <SchedulingHeader
        calenderView={calenderView}
        currentDate={currentDate}
        onChangeView={onChangeView}
        onNextDate={onNextDate}
        onPreviousDate={onPreviousDate}
        onFilterPatientsChanged={onFilterPatientsChanged}
        ordersIds={ordersIds}
        events={events}
        patientsPallette={patientsPallette}
        onlaunchApprovalModal={onlaunchApprovalModal}
        onLaunchReplacementsModal={onLaunchReplacementsModal}
        order_time_extractions={order_time_extractions}
        filteredOrders={filteredOrders}
        activeEmployee={activeEmployee}
      />
      <Spacer vertical={true} />
      <Calender
        patientsPallette={patientsPallette}
        filteredOrders={filteredOrders}
        viewEvent={viewEvent}
        events={calenderEvents}
        currentDate={currentDate}
        onNavigate={onNavigate}
        onCalenderViewChanged={onCalenderViewChanged}
        calenderView={calenderView}
        activeEvent={activeEvent}
        goToDayView={goToDayView}
        holidays={holidays}
        loading={loading}
        absences={monthAbsences}
        changeEvent={changeEvent}
        createEvent={createEvent}
      />
      <ApprovalModal
        onHide={onHideApprovalModal}
        visible={approvalModalVisible}
        currentDate={currentDate}
        onFilterPatientsChanged={onFilterPatientsChanged}
        onNextMonth={onNextMonth}
        onPreviousMonth={onPreviousMonth}
        filteredOrders={filteredOrders}
        events={approvalEvents}
        originalEvents={originalEvents}
        loadLoading={loadLoading}
        ordersIds={ordersIds}
        patientsPallette={patientsPallette}
        reload={reload}
        changeEvents={changeEvents}
        holidays={holidays}
        order_time_extractions={order_time_extractions}
        absences={monthAbsences}
      />

      <EventModal
        activeEvent={activeEvent}
        orders={[...new Set(events.map((obj) => obj.order))]}
        currentDate={currentDate}
        visible={visible}
        handleCancel={handleCancel}
        mode={"edit"}
        editLoading={editLoading}
        originalEmployeeId={
          originalActiveEvent && originalActiveEvent.employee_id
        }
        patient={activeEvent && activePatient}
        setActiveEvent={(event) => setActiveEvent(event)}
        setVisible={(val) => setVisible(val)}
        reload={reload}
        activePatient={activePatient}
      />
      <ReplacementsModal
        onHide={onHideReplacementsModal}
        visible={replacementsModalVisible}
        title={<FormattedMessage id={`app.scheduling.replacementsTitle`} />}
        subTitle={
          <FormattedMessage id={`app.scheduling.replacementsSubTitle`} />
        }
        triggerFetch={triggerFetch}
        triggerQueryTimestamp={triggerQueryTimestamp}
      />
      <AddEmployeeScheduling
        visible={addSchedulingVisible}
        handleCancel={hideEmployeeScheduling}
        activeEmployee={activeEmployee}
        reload={reload}
        currentDate={currentDate}
        employeePatients={employeePatients}
        initialValues={newEventInitialValues}
      />
    </SchedulingWrapper>
  );
};

export default EmployeeScheduling;
